import template from './PaymentState.jade';
import paymentStateCtrl from './PaymentState.controller';
import './PaymentState.css';

export default () => ({
  template,
  controller: paymentStateCtrl,
  controllerAs: 'paymentStateCtrl',
});
